module.exports = __webpack_public_path__ + "img/PERCENT.1cedbfb5.svg";